var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlash1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_8_1",
    "data-name": "Component 8 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.999,
    viewBox: "0 0 24 23.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M31.528,24.195h-8.89v-8.89a.777.777,0,0,0-.778-.778A10.445,10.445,0,1,0,32.306,24.972.777.777,0,0,0,31.528,24.195Zm-9.667,9.667a8.89,8.89,0,0,1-.778-17.746v8.856a.777.777,0,0,0,.778.778h8.856A8.9,8.9,0,0,1,21.861,33.862Zm3.125-22.444h0a.777.777,0,0,0-.778.778v9.667a.777.777,0,0,0,.778.778h9.654a.777.777,0,0,0,.778-.778A10.459,10.459,0,0,0,24.986,11.418Zm.777,9.667V13.008a8.909,8.909,0,0,1,8.065,8.077Z",
    transform: "translate(-11.416 -11.418)",
    fill: "#9e9e9e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash1);
export default __webpack_public_path__ + "static/media/flash1.ff59152e56ae45b1aba4db65359f1c8a.svg";
export { ForwardRef as ReactComponent };